/**FEEDBACK CONTACT PAGE**/
let feedback = document.querySelector('.feedback');
if(feedback)
{
   let formDiv = document.querySelectorAll('form div');
    for(i=0; i< formDiv.length; i++)
    {
        formDiv[i].style.display="none";
    }
}
/****/

/**ORDER SECTION TEXT FIXED MOBILE HOME PAGE**/
let collectionElement = document.querySelector('div#shopify-section-template--15613393338565__165513361901653a42');
let ImageTextElement = document.querySelector('div#shopify-section-template--15613393338565__16550705161dd9bf83')

setInterval(()=>
{
    let widthResponsive = document.body.offsetWidth;
    if (widthResponsive < 1010)
    {
        let heightCollection = document.querySelector('div#shopify-section-template--15613393338565__165513361901653a42').offsetHeight;
        let heightImageText = document.querySelector('div#shopify-section-template--15613393338565__16550705161dd9bf83').offsetHeight;
        collectionElement.style.transform =`translate(0px, -${heightImageText}px ) `;
        ImageTextElement.style.transform =`translate(0px, ${heightCollection}px ) `;
    }else
    {   
        if(collectionElement != null ){
            collectionElement.style.transform =`translate(0px, 0px )`;
            ImageTextElement.style.transform =`translate(0px, 0px )`;
        }

    }
}, 500);
let body = document.querySelector('body');
/****/

/**ITEMS MENU**/
let itemsMenuFooter = document.querySelectorAll(".footer__content--item");
for (i=0; i < itemsMenuFooter.length; i++)
{
  if(itemsMenuFooter.length == 1)
  {
      document.querySelector(".footer__content--items-1").style.width="50%";
      document.querySelector(".footer__content--items-1").style.padding="0  5%";
      document.querySelector(".footer__content--items-2").style.width="50%";
      document.querySelector(".footer__content--items-2").style.justifyContent="center";
      for(i=0; i < itemsMenuFooter.length; i++)
      {
         itemsMenuFooter[i].style.width="auto";     
      }
    
  }else if(itemsMenuFooter.length == 2)
  {
      document.querySelector(".footer__content--items-1").style.width="50%";
      document.querySelector(".footer__content--items-1").style.padding="0  5%";
      document.querySelector(".footer__content--items-2").style.width="50%";
      document.querySelector(".footer__content--items-2").style.justifyContent="space-between";
      for(i=0; i < itemsMenuFooter.length; i++)
      {
         itemsMenuFooter[i].style.width="auto";     
      }
  }else if(itemsMenuFooter.length == 3)
  {
      document.querySelector(".footer__content--items-1").style.width="50%";
      document.querySelector(".footer__content--items-1").style.padding="0  5%";
      document.querySelector(".footer__content--items-2").style.width="50%";
      document.querySelector(".footer__content--items-2").style.justifyContent="space-between";
      for(i=0; i < itemsMenuFooter.length; i++)
      {
         itemsMenuFooter[i].style.width="auto";     
      }
    
  }else
  {
      document.querySelector(".footer__content").style.justifyContent="center";
  }
}
/****/

/**HOVER MENU AND BAR HEADER**/

    let bar = document.querySelector('.announcement');
    let header = document.querySelector('#shopify-section-header');
    let mouseOver = function ()
{
    bar.style.backgroundColor = '#fff';
    let elementStyle = document.createElement('style');
    let textNode = document.createTextNode('.has-image-banner:not(.scrolled-down) .pageheader__contents--overlap .pageheader__layout:before { background-color: #fff;}');
    elementStyle.appendChild(textNode);
    document.head.appendChild(elementStyle);
}

let mouseOut = function ()
{
    bar.style.backgroundColor = '#fff0';
    let elementStyle = document.createElement('style');
    let textNode = document.createTextNode('.has-image-banner:not(.scrolled-down) .pageheader__contents--overlap .pageheader__layout:before { background-color: #fff0;}');
    elementStyle.appendChild(textNode);
    document.head.appendChild(elementStyle);
}

bar.addEventListener('mouseover', mouseOver);
header.addEventListener('mouseover', mouseOver);
bar.addEventListener('mouseout', mouseOut);
header.addEventListener('mouseout', mouseOut);
/****/

/**REMOVE LINKS OF DE SOME ITEMS MENU**/
let noLinksMegamenu = document.querySelectorAll('.nav-row ul.nav-columns .column-title');
for(i = 0; i < noLinksMegamenu.length; i++)
{
	noLinksMegamenu[i].removeAttribute('href');
}
/****/

/**POSITION IMG FIXED**/
setInterval(()=>{ 
    if(document.querySelector('.blue-background') != null){
        let heightImgFixed = document.querySelector('.blue-background').offsetHeight;
    }
    if(document.querySelector('.blue-background .media-with-text__half:nth-child(1)') != null){
        let sectionImgFixed = document.querySelector('.blue-background .media-with-text__half:nth-child(1)').offsetHeight;
        let varStyles = document.createElement('STYLE');
        let contentVarStyle = document.createTextNode(':root{--height-section-img-fixed:' + sectionImgFixed + 'px; --height-img-fixed:' + heightImgFixed + 'px;}');
        varStyles.appendChild(contentVarStyle);
        document.head.appendChild(varStyles);
    }

},1000);

/****/




